// @flow
import * as React from 'react';

type Props = { url: string };

export const ExternalRedirect = ({ url }: Props): React.Node => {
    React.useEffect(() => {
        window.open(url, '_self');
    }, [url]);

    return null;
};

export default ExternalRedirect;
